import ChangelogHeroSection from "./changelog-hero-section";

export default ChangelogHeroSection;
